/**
 * Whether anything about plans may be seen (keepr-web
 * docs/plans/plans-and-pricing.md §4.3, ruling m06).
 *
 * OFF until step 3 ships billing and the pricing page. While it is off:
 *   - the Plan section in Account settings is not rendered, and its read
 *     (`GET /api/users/me/plan`) is never asked;
 *   - a plan-limit refusal never offers "See plans" (there is nowhere to see
 *     them yet). The refusal's words still say what was reached and what
 *     still works — they name no plan — because a limit can only refuse once
 *     the server switch is `enforce` (KPR-1091), and then the person must
 *     know why their add did not land.
 *
 * Turning it on is one line here, in the same change that ships the pricing
 * page. Tests mock this module to see the on state.
 */
export const PLANS_VISIBLE = false;

/** Where "See plans" goes once plans are visible (the pricing page, step 3). */
export const PLANS_PATH = '/account#plan';
